import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import createSessionUserSlice, { type SessionUserSliceState } from './slices/SessionUserState';

const useSessionUserStore = create<SessionUserSliceState>()(
  persist(createSessionUserSlice, {
    name: 'sessionUserStates',
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({ hasNoValidGroups: state.hasNoValidGroups, hasOnlyGroupsWithNoVehicles: state.hasOnlyGroupsWithNoVehicles }),
  })
);

export default useSessionUserStore;
